import { BareButton } from '@calendly/ui/components/bare-button';
import classNames from 'classnames';
import { forwardRef } from 'react';
const callToActionButtonMiniCss = "c1oduqqd";
const callToActionButtonCss = "c9ixlzo";
export const CallToActionButton = forwardRef((props, ref) => {
  const {
    mini,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(callToActionButtonCss, {
    [callToActionButtonMiniCss]: mini
  }, props.className)} />;
});

require("./call_to_action.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./call_to_action.js");